import { render, staticRenderFns } from "./resourceStoreSpecificationManageList.vue?vue&type=template&id=3fc8acb4&scoped=true"
import script from "./resourceStoreSpecificationManageList.vue?vue&type=script&lang=js"
export * from "./resourceStoreSpecificationManageList.vue?vue&type=script&lang=js"
import style0 from "./resourceStoreSpecificationManageList.vue?vue&type=style&index=0&id=3fc8acb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc8acb4",
  null
  
)

export default component.exports